import { dataLayer } from "@repo/analytics/data-layer-utils";
import {
  componentNameConstants,
  dlElementConstants,
  dlEventConstants,
} from "@repo/analytics/data-layer.constants";

export const handleEasyAccess = (
  loginStatus: string,
  section_title: string,
  sub_section: string,
) => {
  const data = {
    component: componentNameConstants.EASY_ACCESS,
    cta_text: sub_section,
    element: dlElementConstants.EASY_ACCESS_LINK_CLICK,
    event: dlEventConstants.CLICK,
    event_type: dlEventConstants.LINK_CLICK,
    section_title,
    sub_section,
  };

  dataLayer(loginStatus, data);
};
